import queryString from 'query-string'
import { MutableRefObject } from 'react'
import { getToken } from './token'

export const host = 'https://' + process.env.AGENT_DOMAIN + '/api/phone/'

const handleAuthError = (status: number) => {
  if (status == 403) {
    window.location.href = '/'
  }
}

export const get = <T>(
  path: string,
  params = {},
  authRefresh = true,
  contrRef: MutableRefObject<AbortController | null> = { current: null }
) =>
  new Promise<T>((resolve, reject) => {
    let ok = false
    let status: number

    contrRef.current = new AbortController()

    const paramsStringified = queryString.stringify({
      ...params,
    })
    const pathParams = path.includes('?')
      ? path + '&' + paramsStringified
      : path + '?' + paramsStringified

    const url = host + pathParams.replace(/\?$/, '')

    // console.log('get', url)

    fetch(url, {
      // credentials: 'include',
      headers: {
        'X-AUTH-TOKEN': getToken(),
      },
      signal: contrRef.current && contrRef.current.signal,
    })
      .then(resp => {
        ok = resp.ok
        status = resp.status

        return resp.json()
      })
      .then(resp => {
        if (authRefresh) {
          handleAuthError(status)
        }

        if (!ok) {
          reject({ resp, status })
          return
        }

        resolve(resp)
      })
      .catch(reject)
  })

export const getAbortable = <T>(
  path: string,
  params: object = {}
): [Promise<T>, () => void] => {
  const contrRef: MutableRefObject<AbortController | null> = { current: null }

  return [
    get<T>(path, params, true, contrRef),
    () => contrRef.current && contrRef.current.abort(),
  ]
}

export const post = <T>(
  path: string,
  body: object = {},
  contrRef: MutableRefObject<AbortController | null> = { current: null }
) =>
  new Promise<T>((resolve, reject) => {
    let ok = false
    let status: number

    contrRef.current = new AbortController()

    const paramsStringified = queryString.stringify({})
    const pathParams = path.includes('?')
      ? path + '&' + paramsStringified
      : path + '?' + paramsStringified

    const url = host + pathParams.replace(/\?$/, '')

    // console.log('post', url)

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
        'X-AUTH-TOKEN': getToken(),
      },
      // credentials: 'include',
      cache: 'no-cache',
      signal: contrRef.current && contrRef.current.signal,
    })
      .then(resp => {
        ok = resp.ok
        status = resp.status

        return resp.json()
      })
      .then(resp => {
        handleAuthError(resp)

        if (!ok) {
          reject({ resp, status })
          return
        }

        resolve(resp)
      })
      .catch(e => {
        if (e.name === 'AbortError') {
          console.warn('aborted /' + path)
          return
        }

        reject(e)
      })
  })

export const postAbortable = <T>(
  path: string,
  body: object = {}
): [Promise<T>, () => void] => {
  const contrRef: MutableRefObject<AbortController | null> = { current: null }

  return [
    post<T>(path, body, contrRef),
    () => contrRef.current && contrRef.current.abort(),
  ]
}
